export enum RedemptionProvider {
  CARD = 'CARD',
  BANK = 'BANK',
  SKRILL = 'SKRILL',
  ACH = 'ACH',
  INTERAC = 'INTERAC',
  PAYOUTS = 'PAYOUTS',
  SEPA = 'SEPA',
  PAYSAFECARD = 'PAYSAFECARD',
}
